import {Injectable} from '@angular/core';
import {UserSessionService} from '../user-session/user-session.service';
import {WebservicesService} from '../webservices/webservices.service';
import {CustomerModel} from '../../models/customer-model';

@Injectable({
  providedIn: 'root',
})
export class MarketingNotificationService {
  private customer: CustomerModel;
  private sessionToken;
  constructor(
    private userSession: UserSessionService,
    private webservice: WebservicesService
  ) {
    this.userSession.getCustomer().subscribe(customer => {
      this.customer = customer;
      this.sessionToken = this.userSession.getSessionToken();
    });
  }
  public callMarkNotificationAsDelivered(notificationID) {
    const obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.sessionToken,
      notification_id: notificationID,
    };
    return this.webservice.post('customer/mark-notification-as-delivered', obj);
  }
  public callUpdateIosRatings(iosRatingAccepted) {
    const obj: any = {
      customer_id: this.customer.customerId,
      session_token: this.sessionToken,
      ios_rating_accepted: iosRatingAccepted,
    };
    return this.webservice.post('customer/update-ios-ratings', obj);
  }
}
